import builder from '../builder';
import MessagesBubbleTyping1 from '../../streamline-icons/light/messages-bubble-typing-1.svg';

export default builder('IconMessagesBubbleTyping1Light', MessagesBubbleTyping1);
